import { z } from "zod";

/**
 * Base metadata contract that every task builder must satisfy.
 *
 * These four fields are present in every task type's metadata today,
 * but were previously defined ad-hoc per builder with inconsistent
 * optionality. This type makes the contract explicit so new builders
 * inherit the shape and the extraction layer (`extractRepositorySlugs`)
 * can rely on a single canonical field set.
 */
export const taskMetadataBaseSchema = z.object({
  /** Flow identification — `kind` is the versioned task type string. */
  flow: z.object({ kind: z.string() }),
  /** Source control provider ID for repo operations. */
  source_control_provider_id: z.string().nullable(),
  /** Repository slugs this task may operate on (modifiable + reference). */
  source_control_repository_allowlist: z.array(z.string()),
  /** Jira/issue ticket key this task is associated with. */
  ticket_id: z.string().nullable(),
});

export type TaskMetadataBase = z.infer<typeof taskMetadataBaseSchema>;
